import { createPivotTransformer } from './create-pivot-transformer';

/**
 * Pivot = mg/L. Assumes dilute aqueous solution where ppm ≡ mg/L.
 * mol/L and meq/L are display-only (no transform) — conversion requires molar/equivalent weight.
 */
export const CONCENTRATION_PIVOT: Record<string, number> = {
  'mg/l': 1,
  ppm: 1,
  ppb: 0.001,
  'ug/l': 0.001,
  'g/l': 1000,
};

export const transformConcentration = createPivotTransformer(CONCENTRATION_PIVOT);
